export default {
	about: 'About us',
	mission: 'Quality management',
	vision: 'Our Vision',
	policy: 'Policy',
	qualityPolicy: 'Quality policy'
}